import React from 'react';
import classNames from 'classnames';

const CondensedLabeledSelect = props => {
    const inheritedClasses = props.className ? props.className.split(' ') : '';
    const selectClasses = classNames(
        'ui',
        'custom-condensed-labeled-select',
        inheritedClasses
    )
    return (
        <div className={selectClasses}>
            {props.children}
        </div>
    );
}

export default CondensedLabeledSelect;